/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ReactTable from 'react-table';

import ConvertDate from '../ConvertDate';
import SocialNetworkIds from './SocialNetworkIds';
import SocialLoginData from './SocialLoginData';
import MemberDevices from './MemberDevices';
import CreateImg from '../CreateImg';

const DisplayMemberInfo = (props) => {
  const { member } = props;
  if (!member) {
    return (<div>Missing member props</div>);
  }

  let possibleDuplicates = null;
  if (get(member.properties, 'possible_duplicates', null)) {
    // eslint-disable-next-line react/prop-types
    possibleDuplicates = member.properties.possible_duplicates.join(', ');
  }
  const memberData = {
    Bilde: {
      props: {
        image: {
          link_base: 'https://s.lindoamor.com/images/get',
          size: 'm',
          img_link: member.profile.image, // get(member, "profile.image", null),
          alt: '',
        },
      },
      target_component: CreateImg,
    },
    ID: member._id,
    'Lietotāja vārds': get(member, 'profile.name', '-'),
    Vecums: get(member, 'profile.age', '-'),
    Dzimums: get(member, 'profile.sex', '-'),
    Epasts: get(member, 'email', '-'),
    IP: get(member, 'properties.ip', '-'),
    Domēns: get(member, 'properties.domain', '-'),
    Valoda: get(member, 'properties.language', '-'),
    'Profila izveides laiks': {
      props: { unix: get(member, 'properties.created.$date.$numberLong', null) },
      target_component: ConvertDate,
    },
    'Epasta aktivizācijas laiks': {
      props: { unix: get(member, 'properties.activated.$date.$numberLong', null) },
      target_component: ConvertDate,
    },
    Atjaunināts: {
      props: { unix: get(member, 'properties.updated.$date.$numberLong', null) },
      target_component: ConvertDate,
    },
    'Pēdējās darbības laiks': {
      props: {
        unix: get(member, 'properties.last_action.$date.$numberLong', null),
      },
      target_component: ConvertDate,
    },
    Statuss: get(member, 'properties.status', '-'),
    'Abonementa beigu laiks': {
      props: {
        unix: String(get(member, 'properties.subscription', 0) * 1000),
      },
      target_component: ConvertDate,
    },
    'Atļauj lietot profila bildi': member.properties.share_profile_image ? 'Jā' : 'Nē',
    'Iespējamie papildus profili': possibleDuplicates || '-',
    'Sociālie tīkli': {
      props: { socialIds: member.properties },
      target_component: SocialNetworkIds,
    },
    'Sociālo loginu dati': {
      props: { loginData: get(member, 'social_login_data', null) },
      target_component: SocialLoginData,
    },
    'Lieto aplikāciju': {
      props: { devices: get(member, 'devices', null) },
      target_component: MemberDevices,
    },
  };

  const data = [];
  Object.keys(memberData).forEach((k) => {
    if (k !== 'Bilde') {
      let value = memberData[k];
      if (memberData[k].props) {
        value = React.createElement(memberData[k].target_component, memberData[k].props);
      }
      data.push({
        name: k,
        value,
      });
    }
  });

  const cellStyleRight = {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '0.3em 1em',
    borderTop: '1px solid #eaedeb',
    borderLeft: '1px solid #eaedeb',
    textAlign: 'left',
    fontSize: '0.9em',
    color: '#111',
  };

  const cellStyleLeft = {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '0.3em 1em',
    borderTop: '1px solid #eaedeb',
    textAlign: 'right',
    fontSize: '0.9em',
    color: '#111',
  };

  const columns = [{
    accessor: 'name',
    Cell: (p) => <span>{p.value}</span>, // eslint-disable-line react/destructuring-assignment
    style: cellStyleLeft,
    minWidth: 350,
  }, {
    accessor: 'value',
    Cell: (p) => <span>{p.value}</span>, // eslint-disable-line react/destructuring-assignment
    style: cellStyleRight,
    minWidth: 350,
  }];

  // kaut kas ar to loading={false},
  // dokumentācijā ir šāds variants, bet te tas kaut kādu iemeslu pēc nestrādā
  return (
    <div style={{ textAlign: 'center' }}>
      {React.createElement(memberData.Bilde.target_component, memberData.Bilde.props)}
      <ReactTable
        data={data}
        columns={columns}
        minRows={3}
        showPagination={false}
        loading={false}
        loadingText=""
      />
    </div>
  );
};

DisplayMemberInfo.propTypes = {
  member: PropTypes.shape({
    _id: PropTypes.string,
    properties: PropTypes.shape({
      possible_duplicates: PropTypes.instanceOf(Array),
      share_profile_image: PropTypes.bool,
    }),
    profile: PropTypes.shape({
      image: PropTypes.string,
    }),
  }).isRequired,
};

export default DisplayMemberInfo;
